import {toPng}  from 'html-to-image';

class ChatBox {
    constructor(params) {
        this.params = params;
        this.messages = [];
        this.allMessagesUpdated = false;
        this.chatTextAreaActive = false;
        this.messagesRendered = 0;
        this.currentMessage = '';

        this.fullChatBox = new THREE.Group();
        this.fullChatBox.visible = false;
        this.chatBoxMessageSprite = null;
        this.chatBoxBottomPanelSprite = null;
        this.chatBoxTopPanelSprite = null;
        this.chatBoxButton = null;
        this.scrollLength = this.params.messagePanelHeight / 4;
        this.allMessagesRead = false;
        this.chatBoxMessagesGeometryWidth = 1;
        this.chatBoxMessagesGeometryHeight = 1;
        this.chatBoxBottomPanelGeometryWidth = 1;
        let extraHeightRatio = this.params.messagePanelHeight / this.params.bottomPanelHeight;
        this.chatBoxBottomPanelGeometryHeight = 1 / extraHeightRatio;
        this.chatBoxTopPanelGeometryWidth = 1;
        extraHeightRatio = this.params.messagePanelHeight / this.params.topPanelHeight;
        this.chatBoxTopPanelGeometryHeight = 1 / extraHeightRatio;
        this.isKeyboardOpen = false;
        this.updatedMessagesImageDataURL = null;

        this.nonVrBottomPanelComponents = [
            {
                type: 'textArea',
                class: "NonVR ChatTextArea",
                id: "chatTextArea",
                onclickCallback: this.updateChatTextAreaStatus.bind(this, true),
                onPasteCallback: this.handlePaste.bind(this),
            },
            {
                type: 'button',
                class: "NonVR ChatSendButton",
                imageClass: 'ChatBoxButtonImage',
                id: "chatSendButton",
                onclickCallback: this.sendChat.bind(this),
                imageSrc: 'toolbarIcons/send.png',
            },
        ];
        this.defaultBottomPanelComponents = [
            {
                type: 'button',
                class: "VR_NonVR ChatScrollUpButton",
                imageClass: 'ChatBoxButtonImage',
                id: "chatScrollUpButton",
                onclickCallback: this.chatScrollUp.bind(this),
                imageSrc: 'toolbarIcons/scrollUp.png',
            },
            {
                type: 'button',
                class: "VR_NonVR ChatScrollDownButton",
                imageClass: 'ChatBoxButtonImage',
                id: "chatScrollDownButton",
                onclickCallback: this.chatScrollDown.bind(this),
                imageSrc: 'toolbarIcons/scrollDown.png',
            },
        ];
        this.vrBottomPanelComponents = [
            {
                type: 'button',
                class: "VR ChatKeyboardButton",
                imageClass: 'ChatBoxButtonImage',
                id: "chatKeyboardButton",
                onclickCallback: this.openKeyboard.bind(this),
                imageSrc: 'toolbarIcons/keyboard.png',
            },
        ];

        this.defaultTopPanelComponents = [
            {
                type: 'span',
                class: "VR_NonVR ChatBoxTitle",
                id: "chatBoxTitle",
                text: "iQ3 Chat Box",
                width: 0.875,
            },
            {
                type: 'button',
                class: "VR_NonVR ChatExitButton",
                id: "chatExitButton",
                imageClass: 'ChatBoxButtonImage',
                imageSrc: 'toolbarIcons/minimize.png',
                onclickCallback: this.onFeatureChange.bind(this),
                width: 0.125,
            },
        ];
    }

    async createChatBoxDom(isVisible) {
        let fullChatBoxDiv = document.getElementById(this.params.fullChatBoxDiv.id);
        if (!fullChatBoxDiv) {
            fullChatBoxDiv = document.createElement('div');
            fullChatBoxDiv.setAttribute('id', this.params.fullChatBoxDiv.id);
            fullChatBoxDiv.setAttribute('class', this.params.fullChatBoxDiv.class);

            const chatBoxTopPanel = document.createElement('div');
            chatBoxTopPanel.setAttribute('id', this.params.chatBoxTopPanelDiv.id);
            chatBoxTopPanel.setAttribute('class', this.params.chatBoxTopPanelDiv.class);

            const chatBoxMessages = document.createElement('div');
            chatBoxMessages.setAttribute('id', this.params.chatBoxMessagesDiv.id);
            chatBoxMessages.setAttribute('class', this.params.chatBoxMessagesDiv.class);

            const chatBoxBottomPanel = document.createElement('div');
            chatBoxBottomPanel.setAttribute('id', this.params.chatBoxBottomPanelDiv.id);
            chatBoxBottomPanel.setAttribute('class', this.params.chatBoxBottomPanelDiv.class);

            fullChatBoxDiv.appendChild(chatBoxTopPanel);
            fullChatBoxDiv.appendChild(chatBoxMessages);
            fullChatBoxDiv.appendChild(chatBoxBottomPanel);
            document.body.appendChild(fullChatBoxDiv);
        }

        this.setChatBoxStyles(this.params);
        this.setChatBoxCallbacks(this.params);
        await this.createChatBoxTopPanelDom();
        this.createChatBoxMessagesDom();
        await this.createChatBoxBottomPanelDom();
        this.setChatBoxVisibility(isVisible);
    }

    setChatBoxCallbacks(params) {
        let self = this;
        const chatBoxMessages = document.getElementById(params.chatBoxMessagesDiv.id);

        chatBoxMessages.addEventListener("wheel", function (event) {
            self.chatScrollIn2D(event.deltaY);
        }, false);

    }

    setChatBoxStyles(params) {
        const fullChatBoxDiv = document.getElementById(this.params.fullChatBoxDiv.id);
        fullChatBoxDiv.style.width = params.totalWidth + 'px';
        fullChatBoxDiv.style.height = params.totalHeight + 'px';

        const chatBoxTopPanel = document.getElementById(this.params.chatBoxTopPanelDiv.id);
        chatBoxTopPanel.style.width = params.totalWidth + 'px';
        chatBoxTopPanel.style.height = params.topPanelHeight + 'px';
        chatBoxTopPanel.style.backgroundColor = this.params.backgroundColor ? this.params.backgroundColor : '#000000';

        const chatBoxMessages = document.getElementById(params.chatBoxMessagesDiv.id);
        chatBoxMessages.style.width = params.totalWidth + 'px';
        chatBoxMessages.style.height = params.messagePanelHeight + 'px';

        const chatBoxBottomPanel = document.getElementById(params.chatBoxBottomPanelDiv.id);
        chatBoxBottomPanel.style.width = params.totalWidth + 'px';
        chatBoxBottomPanel.style.height = params.bottomPanelHeight + 'px';
    }

    createChatBoxMessagesDom() {
        let chatboxMessages = document.getElementById(this.params.chatBoxMessagesDiv.id);

        let initialMessageIndex = this.messages.length - Math.max(wv.effectController.meetingInfo.maxChatMessagesToBeShown, this.messagesRendered);
        chatboxMessages.style.backgroundColor = this.params.backgroundColor ? this.params.backgroundColor : '#00FFFFF';
        initialMessageIndex = initialMessageIndex < 0 ? this.messagesRendered : initialMessageIndex;
        for (let i = initialMessageIndex; i < this.messages.length; i++) {
            let message = this.messages[i];
            let chatElement = document.createElement('div');
            chatElement.setAttribute('class', 'ChatElement');
            chatElement.addStyles({
                lineHeight: "20px",
                marginTop: "10px",
                marginLeft: "5px",
                marginRight: "5px",
                wordBreak: "break-word",
                webkitUserSelect: "text",
                msUserSelect: "text",
                userSelect: "text"
            });

            chatElement.style.width = (this.params.totalWidth - 10) + 'px';

            let senderName = document.createElement('span');
            senderName.style.color = message.senderColor;
            senderName.style.fontWeight = 'bold';
            senderName.appendChild(document.createTextNode(message.senderName + ": "));

            chatElement.appendChild(senderName);

            let senderMessage = this.createMessageSpan(message.message);
            senderMessage.style.color = this.params.messageTextColor ? this.params.messageTextColor : '#000000';

            chatElement.appendChild(senderMessage);
            chatboxMessages.appendChild(chatElement);
        }

        const chatBoxMessagesWidth = this.params.totalWidth - 4;
        chatboxMessages.addStyles({
            display: 'block',
            overflow: 'hidden',
            minHeight: this.params.messagePanelHeight + "px",
            borderStyle: 'solid',
            borderWidth: '1px 2px 1px 2px',
            borderColor: 'black',
            width: chatBoxMessagesWidth + 'px'
        });

        const extraMessages = chatboxMessages.children.length - wv.effectController.meetingInfo.maxChatMessagesToBeShown;

        for (let i = 0; i < extraMessages; i++) {
            chatboxMessages.removeChild(chatboxMessages.firstChild);
        }

        this.messagesRendered = this.messages.length;
        const fullChatbox = document.getElementById(this.params.fullChatBoxDiv.id);
        fullChatbox.style.display = 'block';
        chatboxMessages.scrollTop = chatboxMessages.scrollHeight;
        fullChatbox.style.display = 'none';
    }

    createMessageSpan(message) {
        let messageSpanObject = document.createElement('span');
        let messageLines = message.replace(/\r\n/g, "\n").split("\n");
        for (let messageLine of messageLines) {
            messageSpanObject.appendChild(document.createTextNode(messageLine));
            messageSpanObject.appendChild(document.createElement("br"));
        }

        return messageSpanObject;
    }

    async createChatBoxTopPanelDom() {
        let chatBoxTopPanel = document.getElementById(this.params.chatBoxTopPanelDiv.id);
        if (chatBoxTopPanel && chatBoxTopPanel.children.length > 0) {
            return;
        }

        for (let defaultTopPanelComponent of this.defaultTopPanelComponents) {
            let component = await this.createChatBoxPanelComponent(defaultTopPanelComponent);
            chatBoxTopPanel.appendChild(component);
        }
    }


    async createChatBoxBottomPanelDom() {
        let chatBoxBottomPanel = document.getElementById(this.params.chatBoxBottomPanelDiv.id);
        if (chatBoxBottomPanel && chatBoxBottomPanel.children.length > 0) {
            return;
        }

        for (let nonVrBottomPanelComponent of this.nonVrBottomPanelComponents) {
            let component = await this.createChatBoxPanelComponent(nonVrBottomPanelComponent);
            chatBoxBottomPanel.appendChild(component);
        }

        for (let defaultBottomPanelComponent of this.defaultBottomPanelComponents) {
            let component = await this.createChatBoxPanelComponent(defaultBottomPanelComponent);
            chatBoxBottomPanel.appendChild(component);
        }

        for (let vrBottomPanelComponent of this.vrBottomPanelComponents) {
            let component = await this.createChatBoxPanelComponent(vrBottomPanelComponent);
            chatBoxBottomPanel.appendChild(component);
        }

    }

    async createChatBoxPanelComponent(referenceObject) {
        let component = document.createElement(referenceObject.type);
        component.setAttribute('class', referenceObject.class);
        component.setAttribute('id', referenceObject.id);

        function loadImage(image, imageSource) {
            return new Promise(resolve => {
                image.src = imageSource;
                image.onload = function () {
                    resolve();
                }
            });
        }

        if (referenceObject.type === 'button') {
            const imageIcon = document.createElement('img');
            imageIcon.setAttribute('class', referenceObject.imageClass);
            await loadImage(imageIcon, referenceObject.imageSrc);
            component.appendChild(imageIcon);
        }

        if (referenceObject.type === 'span') {
            const textNode = document.createTextNode(referenceObject.text);
            component.appendChild(textNode);
        }

        component.addEventListener('click', function () {
            referenceObject.onclickCallback();
        });

        if (referenceObject.onPasteCallback) {
            component.addEventListener('paste', function (event) {
                referenceObject.onPasteCallback(event, component);
            });
        }

        return component;
    }

    async makeChatBox(isVisible = false) {
        await this.createChatBoxDom(isVisible);
        const VRon = !!VR.device.isPresenting();
        this.changeChatBoxButtonStyles(VRon);

        if (VRon) {
            await this.createVRChatBox();

            if (!this.fullChatBox.parent) {
                this.addChatBoxToControllerLeft();
            }
        }
    }

    updateChatBox(isVisible = false) {
        this.createChatBoxMessagesDom();
        this.setChatBoxVisibility(isVisible);

        const VRon = !!VR.device.isPresenting();
        this.changeChatBoxButtonStyles(VRon);

        if (VRon) {
            this.updateVRChatBox();
        }
    }

    async createVRChatBox() {
        await this.createChatBoxTopPanelSprite();
        await this.createChatBoxMessagesSprite();
        await this.createChatBoxBottomPanelSprite();

        if (this.fullChatBox.children.length === 0) {
            this.fullChatBox.add(this.chatBoxTopPanelSprite);
            this.fullChatBox.add(this.chatBoxMessageSprite);
            this.fullChatBox.add(this.chatBoxBottomPanelSprite);
            this.fullChatBox.name = this.params.fullChatBoxDiv.name;
        }
    }

    updateVRChatBox() {
        this.createChatBoxTopPanelSprite();
        this.createChatBoxMessagesSprite();
        this.createChatBoxBottomPanelSprite();
    }

    async createChatBoxMessagesSprite() {
        const fullChatbox = document.getElementById(this.params.fullChatBoxDiv.id);
        fullChatbox.style.display = 'block';
        let chatMessagesMaterial = await this.getChatBoxMessagesMaterial();
        if (!this.chatBoxMessageSprite) {
            let chatMessagesGeometry = new THREE.PlaneGeometry(this.chatBoxMessagesGeometryWidth, this.chatBoxMessagesGeometryHeight);
            this.chatBoxMessageSprite = new THREE.Mesh(chatMessagesGeometry, chatMessagesMaterial);
            this.chatBoxMessageSprite.name = this.params.chatBoxMessagesDiv.name;
        }

        this.updateMaterial(this.chatBoxMessageSprite, chatMessagesMaterial);

        fullChatbox.style.display = 'none';
    }

    async getChatBoxMessagesMaterial() {
        let chatMessagesImageData = await this.getImageDataFromChatBox();
        let chatMessagesTexture = await getTextureFromImageData(chatMessagesImageData);

        chatMessagesTexture.colorSpace = THREE.SRGBColorSpace;

        let chatMessagesMaterial = new THREE.MeshBasicMaterial(
            {map: chatMessagesTexture, transparent: true, side: THREE.DoubleSide});
        chatMessagesMaterial.map.minFilter = THREE.LinearFilter;

        return chatMessagesMaterial;
    }

    updateMaterial(sprite, material) {
        if (!sprite) {
            return;
        }

        sprite.material = material;
        sprite.material.needsUpdate = true;
    }

    async createChatBoxTopPanelSprite() {
        if (!this.chatBoxTopPanelSprite) {
            const chatBoxTopPanelMaterial = await this.getChatBoxTopPanelMaterial();
            let chatBoxTopPanelGeometry = new THREE.PlaneGeometry(this.chatBoxTopPanelGeometryWidth, this.chatBoxTopPanelGeometryHeight);

            this.chatBoxTopPanelSprite = new THREE.Mesh(chatBoxTopPanelGeometry, chatBoxTopPanelMaterial);
            this.chatBoxTopPanelSprite.position.y += ((this.chatBoxMessagesGeometryHeight / 2) + (this.chatBoxTopPanelGeometryHeight / 2));
            this.chatBoxTopPanelSprite.name = this.params.chatBoxTopPanelDiv.name;
            this.updateMaterial(this.chatBoxTopPanelSprite, chatBoxTopPanelMaterial);
        }
    }

    async getChatBoxTopPanelMaterial() {
        let chatBoxTopPanelImageData = await this.getChatBoxImageData(this.params.chatBoxTopPanelDiv.id);
        let chatBoxTopPanelTexture = await getTextureFromImageData(chatBoxTopPanelImageData);

        chatBoxTopPanelTexture.colorSpace = THREE.SRGBColorSpace;

        let chatBoxTopPanelMaterial = new THREE.MeshBasicMaterial(
            {map: chatBoxTopPanelTexture, transparent: false, side: THREE.DoubleSide});
        chatBoxTopPanelMaterial.map.minFilter = THREE.LinearFilter;

        return chatBoxTopPanelMaterial;
    }


    async createChatBoxBottomPanelSprite() {
        if (!this.chatBoxBottomPanelSprite) {
            const chatBoxBottomPanelMaterial = await this.getChatBoxBottomPanelMaterial();
            let chatBoxBottomPanelGeometry = new THREE.PlaneGeometry(this.chatBoxBottomPanelGeometryWidth, this.chatBoxBottomPanelGeometryHeight);

            this.chatBoxBottomPanelSprite = new THREE.Mesh(chatBoxBottomPanelGeometry, chatBoxBottomPanelMaterial);
            this.chatBoxBottomPanelSprite.position.y -= ((this.chatBoxMessagesGeometryHeight / 2) + (this.chatBoxBottomPanelGeometryHeight / 2));
            this.chatBoxBottomPanelSprite.name = this.params.chatBoxBottomPanelDiv.name;
            this.updateMaterial(this.chatBoxBottomPanelSprite, chatBoxBottomPanelMaterial);
        }
    }

    async getChatBoxBottomPanelMaterial() {
        let chatBoxBottomPanelImageData = await this.getChatBoxImageData(this.params.chatBoxBottomPanelDiv.id);
        let chatBoxBottomPanelTexture = await getTextureFromImageData(chatBoxBottomPanelImageData);

        chatBoxBottomPanelTexture.colorSpace = THREE.SRGBColorSpace;

        let chatBoxBottomPanelMaterial = new THREE.MeshBasicMaterial(
            {map: chatBoxBottomPanelTexture, transparent: false, side: THREE.DoubleSide});
        chatBoxBottomPanelMaterial.map.minFilter = THREE.LinearFilter;

        return chatBoxBottomPanelMaterial;
    }

    changeChatBoxButtonStyles(inVR) {
        const nonVrElements = document.getElementsByClassName('NonVR');
        const vrElements = document.getElementsByClassName('VR');

        for (let element of nonVrElements) {
            element.style.display = inVR ? 'none' : 'block';
        }

        for (let element of vrElements) {
            element.style.display = inVR ? 'block' : 'none';
        }

    }

    getClone(element) {
        let clone = element.cloneNode(true);
        document.body.appendChild(clone);
        return clone;
    }

    getImageDataFromChatBox() {
        let self = this;

        return new Promise(function (resolve, reject) {
            let chatBoxMessages = document.getElementById(self.params.chatBoxMessagesDiv.id);
            let clone = self.getClone(chatBoxMessages);
            clone.style.height = 'auto';


            let prevClientHeight = clone.clientHeight;

            if (clone.clientHeight < prevClientHeight) {
                clone.style.height = self.params.messagePanelHeight + "px";
            }

            clone.newYPos = chatBoxMessages.scrollTop;

            const chatboxCanvas = document.createElement('canvas');
            chatboxCanvas.setAttribute('class', 'ChatBoxCanvas');

            const canvasWidth = self.params.totalWidth;
            const canvasHeight = self.params.messagePanelHeight;
            chatboxCanvas.width = canvasWidth - 4;
            chatboxCanvas.height = canvasHeight;

            chatboxCanvas.style.width = canvasWidth + "px";
            chatboxCanvas.style.height = canvasHeight + "px";

            if (self.allMessagesUpdated && self.updatedMessagesImageDataURL) {
                self.getCroppedImageData(self.updatedMessagesImageDataURL, 0, clone.newYPos, self.params.totalWidth, self.params.messagePanelHeight, chatboxCanvas)
                    .then(croppedImageURL => {
                        resolve(croppedImageURL);
                    });
            } else {
                toPng(clone)
                    .then(async dataURL => {
                        self.allMessagesUpdated = true;
                        self.updatedMessagesImageDataURL = dataURL;
                        const croppedImageURL = await self.getCroppedImageData(dataURL, 0, clone.newYPos, self.params.totalWidth, self.params.messagePanelHeight, chatboxCanvas);
                        resolve(croppedImageURL);
                    })
                    .catch(error => {
                        reject(error);
                    });
            }

        });

    }

    getCroppedImageData(imageData, startXPos, startYPos, newWidth, newHeight, canvas) {
        return new Promise(function (resolve) {
            const ctx = canvas.getContext("2d");
            let image = new Image();
            let texture = new THREE.Texture(image);

            image.onload = function () {
                ctx.drawImage(image, startXPos, startYPos, newWidth, newHeight, 0, 0, newWidth, newHeight);
                let croppedImageURL = canvas.toDataURL("image/png");

                texture.needsUpdate = true;
                resolve(croppedImageURL);
            };

            image.src = imageData;
        });
    }

    getChatBoxImageData(divId) {
        let self = this;
        return new Promise(function (resolve, reject) {
            let chatBoxPanel = document.getElementById(divId);
            let clone = self.getClone(chatBoxPanel);

            toPng(clone)
                .then(dataURL => {
                    resolve(dataURL);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    updateChatTextAreaStatus(enabled) {
        this.chatTextAreaActive = enabled;
    }

    getChatTextAreaStatus() {
        return this.chatTextAreaActive;
    }

    sendChat(message) {
        let chatTextArea = document.getElementById('chatTextArea');
        message = message ? message : chatTextArea.value;
        if (message.length === 0) {
            return;
        }

        const senderId = wv.effectController.Participants[wv.registeredID].userId ? wv.effectController.Participants[wv.registeredID].userId : wv.registeredID;
        const sender = wv.effectController.Participants[senderId] || wv.effectController.RegisteredParticipants[senderId];
        message = convertMessageFromClient(message);
        wv.sendTextMessage(text_addChatMessage, message, senderId, sender.name);
        chatTextArea.focus();
        this.currentMessage = '';
        chatTextArea.value = '';
        this.isKeyboardOpen = false;
    }

    cancelChat(text) {
        this.isKeyboardOpen = false;
        this.currentMessage = text;
    }

    chatScrollIn2D(amount) {
        const chatBox = document.getElementById(this.params.chatBoxMessagesDiv.id);
        chatBox.scrollBy(0, amount);
    }

    chatScrollUp() {
        const chatBox = document.getElementById(this.params.chatBoxMessagesDiv.id);
        const fullChatbox = document.getElementById(this.params.fullChatBoxDiv.id);
        fullChatbox.style.display = 'block';
        chatBox.scrollBy(0, -this.scrollLength);
        const VRon = !!VR.device.isPresenting();
        if (VRon) {
            this.createVRChatBox();
        }
    }

    chatScrollDown() {
        const chatBox = document.getElementById(this.params.chatBoxMessagesDiv.id);
        const fullChatbox = document.getElementById(this.params.fullChatBoxDiv.id);
        fullChatbox.style.display = 'block';
        chatBox.scrollBy(0, this.scrollLength);
        const VRon = !!VR.device.isPresenting();
        if (VRon) {
            this.createVRChatBox();
        }
    }

    openKeyboard() {
        let keyboardCallbacks = {};
        keyboardCallbacks.enterCallback = this.sendChat;
        keyboardCallbacks.cancelCallback = this.cancelChat;
        this.isKeyboardOpen = true;

        keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks, this.currentMessage);
    }

    closeKeyboard() {
        this.isKeyboardOpen = false;
        keyboardController.closeKeyboard();
    }

    async toggleChatboxVisibility() {
        const fullChatBoxDiv = document.getElementById(this.params.fullChatBoxDiv.id);

        if (!fullChatBoxDiv) {
            await this.makeChatBox();
        }
        const VRon = !!VR.device.isPresenting();
        if (VRon && !this.fullChatBox.parent) {
            await this.createVRChatBox();
        }

        const isChatboxVisible = !!((fullChatBoxDiv && fullChatBoxDiv.style.display === 'block') || (this.fullChatBox && this.fullChatBox.visible));
        this.setChatBoxVisibility(!isChatboxVisible);

        if (!isChatboxVisible) {
            wv.sendTextMessage(text_getChatMessage, this.messagesRendered);
        }

        menuViewToolbarController.setToolbarItemStatusById('chatMessages', !isChatboxVisible);
        menuViewToolbarController.updateShow2dToolbarIcon();
        menuViewToolbarController.updateMessageButton(!isChatboxVisible);
    }

    setChatBoxVisibility(isVisible) {
        const fullChatBoxDiv = document.getElementById(this.params.fullChatBoxDiv.id);

        const VRon = !!VR.device.isPresenting();
        wv.effectController.isChatBoxVisible = isVisible;
        if (VRon) {
            this.fullChatBox.visible = isVisible;
        }
        else if (fullChatBoxDiv?.style) {
            fullChatBoxDiv.style.display = isVisible ? 'block' : 'none';
        }

        !isVisible && this.isKeyboardOpen ? this.closeKeyboard() : '';

        this.allMessagesRead = isVisible ? true : this.allMessagesRead;
    }

    async showChatBoxOnVrModeChange() {
        const fullChatBoxDiv = document.getElementById(this.params.fullChatBoxDiv.id);
        if (!fullChatBoxDiv) {
            return;
        }
        const VRon = !!VR.device.isPresenting();
        this.changeChatBoxButtonStyles(VRon);

        let isChatboxVisible = !!(fullChatBoxDiv && fullChatBoxDiv.style.display === 'block');
        if (VRon && isChatboxVisible) {
            await this.createVRChatBox();
            this.addChatBoxToControllerLeft();
        }

        isChatboxVisible = !!(isChatboxVisible || (this.fullChatBox && this.fullChatBox.visible));

        this.setChatBoxVisibility(isChatboxVisible);

        if (VRon) {
            fullChatBoxDiv.style.display = 'none';
        } else {
            this.fullChatBox.visible = false;
        }
    }


    handleMouseDown(object, pickingPoint) {
        if (object.name === this.params.chatBoxBottomPanelDiv.name) {
            object.worldToLocal(pickingPoint);

            let vrButtons = [];
            vrButtons.push(...this.defaultBottomPanelComponents);
            vrButtons.push(...this.vrBottomPanelComponents);

            let startingX = -0.5;
            let endingX = 0.5;
            let panelWidth = endingX - startingX;

            vrButtons.forEach(vrButton => {
                vrButton.startingX = startingX;
                vrButton.endingX = vrButton.startingX + (panelWidth / vrButtons.length);
                startingX = vrButton.endingX;
                if (pickingPoint.x >= vrButton.startingX && pickingPoint.x < vrButton.endingX) {
                    vrButton.onclickCallback();
                }
            });

            return true;
        } else if (object.name === this.params.chatBoxMessagesDiv.name) {
            return true;
        }

        return false;
    }

    handleControllerTriggerDown(object, pickingPoint) {
        if (object.name === this.params.chatBoxBottomPanelDiv.name) {
            object.worldToLocal(pickingPoint);

            let vrButtons = [];
            vrButtons.push(...this.defaultBottomPanelComponents);
            vrButtons.push(...this.vrBottomPanelComponents);

            let startingX = -0.5;
            let endingX = 0.5;
            let panelWidth = endingX - startingX;

            vrButtons.forEach(vrButton => {
                vrButton.startingX = startingX;
                vrButton.endingX = vrButton.startingX + (panelWidth / vrButtons.length);
                startingX = vrButton.endingX;
                if (pickingPoint.x >= vrButton.startingX && pickingPoint.x < vrButton.endingX) {
                    vrButton.onclickCallback();
                }
            });

            return true;
        } else if (object.name === this.params.chatBoxTopPanelDiv.name) {
            object.worldToLocal(pickingPoint);

            const vrButtons = this.defaultTopPanelComponents;

            let startingX = -0.5;
            let endingX = 0.5;
            let panelWidth = endingX - startingX;

            vrButtons.forEach(vrButton => {
                vrButton.startingX = startingX;
                vrButton.endingX = vrButton.startingX + (panelWidth * vrButton.width);
                startingX = vrButton.endingX;
                if (pickingPoint.x >= vrButton.startingX && pickingPoint.x < vrButton.endingX && vrButton.onclickCallback) {
                    vrButton.onclickCallback();
                }
            });

            return true;
        }

        return false;
    }

    handlePaste(event, component) {
        event.stopPropagation();
        event.preventDefault();

        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('Text');

        component.value += pastedData;
    }

    addChatBoxToControllerRight() {
        this.fullChatBox.position.set(-0.11, 0.017, 0.19);
        this.fullChatBox.scale.set(0.2, 0.2, 1);
        this.fullChatBox.rotation.x = -Math.PI / 2;
        wv.controllerRight.add(this.fullChatBox);
    }

    addChatBoxToControllerLeft() {
        this.fullChatBox.position.set(0.11, 0.017, 0.19);
        this.fullChatBox.scale.set(0.2, 0.2, 1);
        this.fullChatBox.rotation.x = -Math.PI / 2;
        wv.controllerLeft.add(this.fullChatBox);
    }

    onFeatureChange() {
        const value = !wv.effectController.isChatBoxVisible;
        this.toggleChatboxVisibility();
        checkBoxSyncVR('chatBoxVisibility', value);
        wv.pinMenuController.resetVisibility();
    }

    updateChatBoxVisibilityOnPresenterChange() {
        if (!FeatureAccessController.hasAccess(FeatureEnum.CHATBOX)) {
            this.setChatBoxVisibility(false);
        }
    }

}

export default ChatBox;
